import { SceneEventsController } from "./SceneEventsController";
import { DragEventsController } from "./DragEventsController";
import { KeyboardEventsController } from "./KeyboardEventsController";
import { MouseEventsController } from "./MouseEventsController";
import { PointerEventsController } from "./PointerEventsController";
import { WindowEventsController } from "./WindowEventsController";
import { TouchEventsController } from "./TouchEventsController";
import { SceneConnectionTriggerDispatcher } from "./ConnectionTriggerDispatcher";
import { EventInputType } from "../../../poly/registers/nodes/types/Event";
import { ActorType } from "../../../poly/registers/nodes/types/Actor";
export class SceneEventsDispatcher {
  constructor(scene) {
    this.scene = scene;
    this.sceneEventsController = new SceneEventsController();
    this._controllers = [];
  }
  registerActorNode(node) {
    const controller = this._findOrCreateControllerForActorNode(node);
    if (controller) {
      controller.registerActorNode(node);
    }
  }
  unregisterActorNode(node) {
    const controller = this._findOrCreateControllerForActorNode(node);
    if (controller) {
      controller.unregisterActorNode(node);
    }
  }
  registerEventNode(node) {
    const controller = this._findOrCreateControllerForEventNode(node);
    if (controller) {
      controller.registerEventNode(node);
    }
  }
  unregisterEventNode(node) {
    const controller = this._findOrCreateControllerForEventNode(node);
    if (controller) {
      controller.unregisterEventNode(node);
    }
  }
  updateViewerEventListeners(node) {
    const controller = this._findOrCreateControllerForEventNode(node);
    if (controller) {
      controller.updateViewerEventListeners();
    }
  }
  traverseControllers(callback) {
    for (let controller of this._controllers) {
      callback(controller);
    }
  }
  _findOrCreateControllerForEventNode(node) {
    switch (node.type()) {
      case EventInputType.KEYBOARD:
        return this.keyboardEventsController;
      case EventInputType.MOUSE:
        return this.mouseEventsController;
      case EventInputType.DRAG:
        return this.dragEventsController;
      case EventInputType.POINTER:
        return this.pointerEventsController;
      case EventInputType.TOUCH:
        return this.touchEventsController;
      case EventInputType.WINDOW:
        return this.windowEventsController;
    }
  }
  _findOrCreateControllerForActorNode(node) {
    switch (node.type()) {
      case ActorType.ON_OBJECT_CLICK:
      case ActorType.ON_OBJECT_HOVER:
      case ActorType.ON_OBJECT_POINTER_DOWN:
      case ActorType.ON_OBJECT_POINTER_UP:
      case ActorType.ON_POINTER_UP:
      case ActorType.RAY_FROM_CURSOR:
        return this.pointerEventsController;
    }
    console.warn(`no event controller defined for node`, node);
  }
  get keyboardEventsController() {
    return this._keyboardEventsController = this._keyboardEventsController || this._createController(KeyboardEventsController);
  }
  get mouseEventsController() {
    return this._mouseEventsController = this._mouseEventsController || this._createController(MouseEventsController);
  }
  get dragEventsController() {
    return this._dragEventsController = this._dragEventsController || this._createController(DragEventsController);
  }
  get pointerEventsController() {
    return this._pointerEventsController = this._pointerEventsController || this._createController(PointerEventsController);
  }
  get windowEventsController() {
    return this._windowEventsController = this._windowEventsController || this._createController(WindowEventsController);
  }
  get touchEventsController() {
    return this._touchEventsController = this._touchEventsController || this._createController(TouchEventsController);
  }
  _createController(eventConstructor) {
    const controller = new eventConstructor(this);
    if (!this._controllers.includes(controller)) {
      this._controllers.push(controller);
    }
    return controller;
  }
  get connectionTriggerDispatcher() {
    return this._connectionTriggerDispatcher = this._connectionTriggerDispatcher || new SceneConnectionTriggerDispatcher();
  }
}
